import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import AdminPage from './pages/AdminPage';
import ClientEntry from './pages/ClientEntry';
import ClientInfo from './pages/ClientInfo';
import StatementModal from './components/StatementModal';
import FaceVerify from './pages/FaceVerify';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard'; // 新增
import FaceVerifyResult from './pages/FaceVerifyResult';
import SignBefore from './pages/SignBefore';
import Signing from './pages/Signing';

// 导航栏组件
const Navbar = ({ mode, setMode }) => (
  <header className="App-header" style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 32px',
    width: '100%',
    boxSizing: 'border-box'
  }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <img src="/policelogo.png" alt="警徽" style={{ height: 36, marginRight: 12 }} />
      <span>公安备案 全市通办</span>
    </div>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <button
        onClick={() => setMode(mode === 'admin' ? 'client' : 'admin')}
        style={{
          background: 'var(--primary-color)',
          border: 'none',
          color: '#fff',
          fontSize: 'clamp(11px, 2.2vw, 13px)',
          cursor: 'pointer',
          padding: 'clamp(4px, 1.2vw, 6px) clamp(10px, 2.2vw, 14px)',
          borderRadius: 'clamp(3px, 0.8vw, 5px)',
          fontWeight: '500',
          transition: 'all 0.2s ease',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          height: '28px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        onMouseOver={(e) => {
          e.target.style.background = '#0056b3';
          e.target.style.transform = 'translateY(-1px)';
          e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
        }}
        onMouseOut={(e) => {
          e.target.style.background = 'var(--primary-color)';
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
        }}
      >
        {mode === 'admin' ? '切换到客户端' : '切换到管理端'}
      </button>
    </div>
  </header>
);

// 主应用内容组件
function AppContent() {
  const location = useLocation();
  const [org, setOrg] = useState(null);
  const [partners, setPartners] = useState([]);
  const [files, setFiles] = useState([]);
  const [queryValue, setQueryValue] = useState('');
  const [code, setCode] = useState('');
  const [mode, setMode] = useState('client'); // 'admin' or 'client'
  const [loading, setLoading] = useState(false);

  // 检查token有效性
  const checkTokenValidity = async () => {
    const token = localStorage.getItem('adminToken');
    if (!token) return;
    try {
      const response = await fetch(`/api/adminAuth/checkToken`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        // Token无效或被挤下线
        localStorage.removeItem('adminToken');
        alert('您的账号已在其他地方登录，请重新登录');
        window.location.reload();
      }
    } catch (error) {
      console.error('Token检查失败:', error);
    }
  };

  // 定期检查token有效性（每30秒检查一次）
  useEffect(() => {
    const interval = setInterval(checkTokenValidity, 30000);
    return () => clearInterval(interval);
  }, []);

  // 查询订单信息
  const queryOrder = async (orderCode, code) => {
    setLoading(true);
    try {
      const res = await fetch(`/api/client/orderByCode?query=${encodeURIComponent(orderCode)}&code=${code}`);
      const data = await res.json();
      if (data.org && data.partners) {
        setOrg(data.org);
        setPartners(data.partners);
        setQueryValue(orderCode);
        setCode(code);
        setFiles(data.fileList || []);
          // 调试日志
          console.log("Files from API:", data.fileList);
      } else {
        console.error('查询订单失败:', data);
      }
    } catch (error) {
      console.error('查询订单出错:', error);
    } finally {
      setLoading(false);
    }
  };

  // 检查URL参数中的orderCode和code
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const orderCode = urlParams.get('orderCode');
    const code = urlParams.get('code');
    if (orderCode && code && !org) {
      queryOrder(orderCode, code);
    }
  }, [location.search, org]);

  // 查询成功后回调
  const handleQuerySuccess = (org, partners, queryValue, code,files) => {
   /* const { isNotSignFile, situationChecked, situationUrl, situationName,
      resolutionChecked, resolutionUrl, resolutionName,
      customize1Checked, customize1Url, customize1Name,
      customize2Checked, customize2Url, customize2Name } = org;
    const fileList = [];
    if (situationChecked) {
      fileList.push({
        fileUrl: situationUrl,
        fileName: situationName,
        fileType: '情况说明',
        isLook: false
      })
    }
    if (resolutionChecked) {
      fileList.push({
        fileUrl: resolutionUrl,
        fileName: resolutionName,
        fileType: '股东会决议',
        isLook: false
      })
    }
    if (customize1Checked) {
      fileList.push({
        fileUrl: customize1Url,
        fileName: customize1Name,
        fileType: '自定义文件1',
        isLook: false
      })
    }
    if (customize2Checked) {
      fileList.push({
        fileUrl: customize2Url,
        fileName: customize2Name,
        fileType: '自定义文件2',
        isLook: false
      })
    }
    setFiles(fileList);*/
    setFiles(files || []);  // 确保有默认值
    setOrg(org);
    setPartners(partners);
    setQueryValue(queryValue);
    setCode(code);
    console.log("Files from handleQuerySuccess:", files);
  };

  // 刷新订单和参与人信息
  const refreshOrder = async () => {
    const res = await fetch(`/api/client/orderByCode?query=${encodeURIComponent(queryValue)}&code=${code}`);
    const data = await res.json();
    if (data.org && data.partners) {
      setOrg(data.org);
      setPartners(data.partners);
      setFiles(data.fileList || []);
    }
  };

  // 检查是否在认证结果页面
  const isHideNavbar = ['/verify-result', '/sign-before', '/signing'].indexOf(location.pathname) > -1;

  return (
    <div className="App">
      {/* 只在非认证结果页面显示导航栏 */}
      {!isHideNavbar && <Navbar mode={mode} setMode={setMode} />}
      <main style={{
        maxWidth: 900,
        margin: isHideNavbar ? '0 auto' : '32px auto',
        width: '100%',
        padding: isHideNavbar ? '0' : '0 20px'
      }}>
        <Routes>
          <Route path="/verify-result" element={<FaceVerifyResult />} />
          <Route
            path="/"
            element={
              mode === 'admin' ? (
                <AdminDashboard />
              ) : !org ? (
                <ClientEntry onSuccess={handleQuerySuccess} />
              ) : (
                <ClientInfo
                  org={org}
                  files={files}
                  partners={partners}
                  refreshOrder={refreshOrder}
                  onBack={() => {
                    setOrg(null);
                    setPartners([]);
                    setQueryValue('');
                    setCode('');
                    setFiles([]);
                  }}
                />
              )
            }
          />
          <Route path="/sign-before" element={<SignBefore />} />
          <Route path="/signing" element={<Signing />} />
          {/* 你可以继续添加其他路由 */}
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
